import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import { SectionProps } from "./types";

export const CustomSection: React.FC<SectionProps> = ({
  headline,
  sectionId,
  onSectionInView,
  isPortfolio = false,
  isFooter = false,
}) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, {
    amount: 0.6,
    margin: "-10% 0px -10% 0px",
  });

  useEffect(() => {
    if (isInView && sectionId && onSectionInView) {
      onSectionInView(sectionId);
    }
  }, [isInView, sectionId, onSectionInView]);

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  const contentVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        delay: 0.2,
      },
    },
  };

  return (
    <motion.div
      className={`snap-start w-screen relative flex justify-center ${
        isFooter
          ? "min-h-screen items-end"
          : "h-screen items-center"
      }`}
      ref={sectionRef}
      variants={containerVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <motion.div
        className={isPortfolio ? "w-full h-full" : "w-full"}
        variants={contentVariants}
      >
        {headline}
      </motion.div>
    </motion.div>
  );
};
